<template>
  <van-overlay :show="show" @click.stop>
    <div class="overlay-container">
      <div id="overlay-content">
        <div class="snap-button" @click="$parent.takeNewyearCoupons" />
      </div>
      <van-icon class="close" name="cross" size="2em" color="#A0A0A0" @click="hideOverlay" />
    </div>
  </van-overlay>
</template>

<script>
import lottie from 'lottie-web'
import datajson from '@/assets/newyear-overlay.json'

export default {
  name: 'NewyearOverlay',
  data() {
    return {
      show: false
    }
  },
  mounted() {
    this.init()
  },
  beforeDestroy() {
    lottie.destroy()
  },
  methods: {
    init() {
      const container = document.getElementById('overlay-content')
      lottie.loadAnimation({
        container: container, // 包含动画的dom元素
        renderer: 'svg', // 渲染出来的是什么格式
        loop: true, // 循环播放
        autoplay: true, // 自动播放
        animationData: datajson // 动画json的路径
      })
    },
    showOverlay() {
      this.show = true
      lottie.play()
    },
    hideOverlay() {
      this.show = false
      lottie.stop()
    }
  }
}
</script>

<style lang="less" scoped>
.overlay-container {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  position: relative;
}

#overlay-content {
  position: relative;
}

.snap-button {
  position: absolute;
  bottom: 5px;
  left: 0;
  right: 0;
  width: 240px;
  height: 80px;
  margin: auto;
  z-index: 1;
}

.close {
  position: absolute;
  top: 20px;
  right: 20px;
}
</style>
